export const getCourseMetadata = (course) => {
  const {
    CRNS,
    CRN,
    SSBSECT_TERM_CODE,
    TERM_CODE,
    COURSE_NUMBER,
    COURSE_TITLE,
    SUBJECT_CODE,
    SUBJECT_5,
    COURSE_NUMBER_5,
    COURSE_TITLE_5,
  } = course;

  const crn = (CRNS || CRN).split(',')[0];
  const termCode = SSBSECT_TERM_CODE || TERM_CODE;
  const subjectCode = SUBJECT_CODE || SUBJECT_5;
  const courseNumber = COURSE_NUMBER || COURSE_NUMBER_5;
  const courseTitle = COURSE_TITLE || COURSE_TITLE_5;

  const name = `${termCode}_${subjectCode}_${courseNumber}_${courseTitle.toUpperCase()}`.replaceAll(
    /[@()\\[\]"`;:.<> ,]/g,
    '',
  );

  const encodedName = encodeURIComponent(name);

  return {
    name,
    encodedName,
    crn,
    termCode,
    subjectCode,
    courseNumber,
    courseTitle,
  };
};

/**
 * Returns true if the given student courses is in teaching courses.
 */
export const verifyFullPermission = (studentCourse, teachingCourses) => {
  const isTeaching = teachingCourses.find(
    ({ CRNS: crns, CRN: crn, SSBSECT_TERM_CODE: termCode }) =>
      (studentCourse.CRNS || studentCourse.CRN) === (crns || crn) &&
      studentCourse.SSBSECT_TERM_CODE === termCode,
  );

  if (isTeaching) {
    return true;
  }

  return false;
};
